import { render, staticRenderFns } from "./AlertRelatedProcesses.vue?vue&type=template&id=14c66115&scoped=true&"
import script from "./AlertRelatedProcesses.vue?vue&type=script&lang=js&"
export * from "./AlertRelatedProcesses.vue?vue&type=script&lang=js&"
import style0 from "./AlertRelatedProcesses.vue?vue&type=style&index=0&id=14c66115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c66115",
  null
  
)

export default component.exports